<div class="tnc-section-container">
    <div class="tnc-section-content">
        <div class="tnc-section-header" [ngStyle]="{'background-image': 'url(' + backgroundURL + ')'}">
            <div class="tnc-title">{{TnCCMSData?.tnCTitle}}</div>
        </div>

        <div class="tnc-container">
            <div *ngFor="let section of getTnCDetails; let i = index" class="tnc-section">
                <!-- comment code is as per generic Design Do not Delete-->
                <!-- <div class="tnc-header" (click)="toggleSection(i)">
                    <div class="tnc-header-title">{{ section.sectionTitle }}</div>
                    <span class="toggle-icon" *ngIf="openSections[i]">
                        <img src="assets/images/icons/collapse_outline_white.png" height="8px" width="8px">
                    </span>
                    <span class="toggle-icon" *ngIf="!openSections[i]">
                        <img src="assets/images/icons/expand_outline_white.png" height="8px" width="8px">
                    </span>
                </div>
        
                <div *ngIf="openSections[i]" class="tnc-content">
                    <ngx-contentful-rich-text class="text-here" [document]="TnCCMSData.tnCHeaderContent"></ngx-contentful-rich-text>
                    <div *ngFor="let item of section.tnCFaqQnA" class="tnc-item">
                        <div class="bullet"></div>
                        <div class="tnc-text">
                            <markdown id="nav-content" class="text-here" [data]="item.fields.genericAnswer"></markdown>
                        </div>
                    </div>
                </div> -->

                <div class="tnc-content">
                    <ngx-contentful-rich-text class="tnc-header-title" [document]="TnCCMSData.tnCHeaderContent"></ngx-contentful-rich-text>

                    <div *ngFor="let term of TnCCMSData.tnCList" class="tnc-text">
                        <div class="tnc-text-question">{{term?.fields.heading}}</div>
                        <ngx-contentful-rich-text class="tnc-text-answer" [document]="term?.fields.termsContent"></ngx-contentful-rich-text>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>